import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers   } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable }  from 'rxjs/Observable';

import { FormulaCobro } from '../model/formula-cobro';
import { UtilitiesService } from '../services/utilities.service'

@Injectable()
export class FormulaCobroService {

   private FormulaCobro: Observable<FormulaCobro[]>;

   constructor(
    private _http: Http,
    private _utilities:UtilitiesService
  ) { }

 
  getFormulasCobros(query:any) : Observable<FormulaCobro[]> {
    
    let json = {   "Metodo": "getFormulasCobros",   "Datos":  query};

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
    
		return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());
   }


}
 


// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/formula-cobro.service.ts